<template>
  <!--begin::Content wrapper-->
  <div
    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    class="modal fade forgetpassword-modal qbank-section"
    id="add-note-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            {{ $t("qbank.note.add_note") }}
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> {{ $t("qbank.note.close") }}
          </button>
        </div>
        <div class="modal-body">
          <h4 class="mb-2 text-center support-text">
            <div class="mb-2">{{ $t("qbank.note.adding_note") }}</div>
            <br />
          </h4>

          <form @submit.prevent="handleSubmit" class="form-horizontal">
            <div class="row" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
              <div class="col-md-12">
                <input type="hidden" id="qbankNoteId" />
                <input type="hidden" id="questionNoteId" />

                <div class="form-group w-100">
                  <label class="form-label fw-bold mb-3">{{
                    $t("qbank.note.note_content")
                  }}</label>
                  <textarea
                    type="text"
                    class="form-control"
                    name="note-content"
                    id="note-content"
                    v-model="noteContent"
                  ></textarea>
                </div>
              </div>
            </div>

            <hr />

            <div
              class="text-end d-flex justify-content-between align-items-center mt-4"
            >
              <button
                type="button"
                class="btn btn-outline-secondary rounded-pill px-4"
                data-bs-dismiss="modal"
              >
                <i class="fa fa-arrow-right me-2"></i>
                {{ $t("qbank.note.back") }}
              </button>
              <button
                class="btn btn-success rounded-pill px-4 d-flex align-items-center"
                type="submit"
                :disabled="isLoading || !isFormValid"
              >
                <i class="fa fa-check me-2"></i> {{ $t("qbank.note.submit") }}
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm ms-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "ChangeName",
  data() {
    return {
      token: localStorage.getItem("access_token"),

      isLoading: false,
      noteContent: "",
    };
  },
  computed: {
    isFormValid() {
      return this.noteContent && this.noteContent.trim().length > 0;
    },
  },
  methods: {
    handleSubmit() {
      this.submitNote();
    },
    async submitNote() {
      let qbankNoteId = document.getElementById("qbankNoteId").value;
      let questionNoteId = document.getElementById("questionNoteId").value;
      try {
        const result = await Swal.fire({
          title: this.$t("qbank.note.confirm_operation"),
          text: " ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: this.$t("qbank.note.no"),
          confirmButtonText: this.$t("qbank.note.yes"),
        });

        if (result.isConfirmed) {
          this.isLoading = true;
          const response = await fetch(
            `${apiUrl}/qbanks/${qbankNoteId}/questions/${questionNoteId}/notes`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.token}`,
              },
              body: JSON.stringify({ content: this.noteContent }),
            }
          );

          if (!response.ok) {
            const errorResponse = await response.json();
            throw errorResponse;
          }

          Swal.fire({
            icon: "success",
            title: this.$t("qbank.note.sent_successfully"),
            text: "",
          });

          this.noteContent = "";

          const modal = document.getElementById("add-note-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) {
            modalInstance.hide();
          }

          this.isLoading = false;
        }
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        Swal.fire(
          this.$t("qbank.note.error"),
          this.$t("qbank.note.error_message"),
          "error"
        );
      }
    },
    changeMode(questionBank) {
      const input = document.getElementById("qbankId");
      if (input) {
        input.value = questionBank.id;
      }
    },
  },
};
</script>
